<template>
  <div class="BaseRow">
    <slot />
  </div>
</template>

<style lang="postcss">
.BaseRow {
  @apply flex flex-wrap relative;

  .BaseColumn {
    @apply first:mt-md md:first:mt-0;
  }

  .BaseColumn:not(:last-of-type) {
    @screen mdMax {
      @apply mb-10;
    }
  }
}
</style>
